// Auto-generated from proto definitions. DO NOT EDIT.

export type Currency = 'CURRENCY_UNSPECIFIED' | 'CURRENCY_USD' | 'CURRENCY_EUR' | 'CURRENCY_RUB' | 'CURRENCY_GBP' | 'CURRENCY_JPY' | 'CURRENCY_CNY' | 'CURRENCY_KZT' | 'CURRENCY_BYN' | 'CURRENCY_AED' | 'CURRENCY_TRY';

export const CurrencyValues = ['CURRENCY_UNSPECIFIED', 'CURRENCY_USD', 'CURRENCY_EUR', 'CURRENCY_RUB', 'CURRENCY_GBP', 'CURRENCY_JPY', 'CURRENCY_CNY', 'CURRENCY_KZT', 'CURRENCY_BYN', 'CURRENCY_AED', 'CURRENCY_TRY'] as const;
